import React from 'react';
import { Loader } from './styled';

// Note: keep alt text as it is useful for testing
export default () => (
  <Loader>
    <img alt="Loading" style={{ display: "none" }} />
  </Loader>
);
